<app-user-header class="d-md-none"></app-user-header> 


<div class="wrapperi pb-4 ">
    <div class="col-12 ps-2 pe-2 m-0 pt-4">
        <app-top-banner [backgroundClass]="'banner-green-bg'" [title]="'Foorumed'" [buttonText]="'Lisää työpaikka'" [imgSrc]="'../../assets/icons/dashboard_icon.svg'"  [subtitle]="'OSallistu keskusteluun polttavimmista aiheista!'"></app-top-banner>
    </div>
    <div class="col-12 ps-2 pe-2">
        <div class="card p-3 mt-2" (click)="routeToTopic(data)" *ngFor="let data of topics">
            <p>{{data['unicode_title'] ? data['unicode_title'] : data['title']}}</p>
            <p><i class="fal fa-comments me-2"></i>{{data['posts_count']}}</p>
            <p><i class="fal fa-heart me-2"></i>{{data['like_count']}}</p>
            <p><i class="fal fa-calendar-alt me-2"></i>{{data['last_posted_at'] | formateDate}}</p>

        </div>

    </div>
  
</div>

                <!-- Modal Check before deleting offer -->
                <button data-bs-toggle="modal" id="no_user" data-bs-target="#no_user_modal" style="display:none"></button>
                <div class="modal fade" id="no_user_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class=" w-100 modal-title" id="exampleModalLabel">Valitse käyttäjätunnus</h5>
                        <!-- <p>Kaikki tähdellä merkityt kentät ovat pakollisia</p> -->
                        <button id="close_modal" type="button" class="btn-close" data-bs-dismiss="modal">
                            <i class="fal fa-times"></i>
                            </button>
                    </div>
                    <div class="modal-body">
                        <ng-container *ngIf="no_user_account">
                            <p class="normaltextblue14">Kirjoita haluamasi julkinen käyttäjätunnus.</p>

                            <div class="form-floating mb-2 col-12 col-md-12 p-0">
                                <input type="text" min="0" placeholder="Käyttäjätunnus" id="userName" class="form-control" >
                                <label for="wage_hourly">Käyttäjätunnus</label>
                    
                                </div>
    
                            <div id="loader" class="loader-container mt-4" *ngIf="isLoading">
                                <div class="loader mx-auto"></div>
                                <p class="text-center pt-3">Tietoja tallennetaan...</p>
                                </div>


                        </ng-container>

                        
        
                        <div class="text-center justify-content-between d-flex col-12 mt-4 ">
                            <button class="btn btn-formed-main-blue mt-4" (click)="startForum()">Tallenna</button>
                        </div>
        
                    </div>
                    </div>
                </div>
                </div>
